import type { PayloadAction } from '@reduxjs/toolkit'
import { createSlice } from '@reduxjs/toolkit'
import type { Review, FilterType, ISort } from '@homeviews/models'

export const REVIEWS_FEATURE_KEY = 'reviews'

type ReviewsState = {
  reviews: Review[]
  activeReview?: Review
  filters: any
  sort?: ISort
}

const initialReviewsState: ReviewsState = {
  reviews: [],
  activeReview: null,
  filters: {},
  sort: null,
}

export const reviewsSlice = createSlice({
  name: REVIEWS_FEATURE_KEY,
  initialState: initialReviewsState,
  reducers: {
    setReviews: (
      state,
      { payload: { reviews } }: PayloadAction<{ reviews: Review[] }>,
    ) => {
      state.reviews = reviews
    },
    setActiveReview: (
      state,
      { payload: { review } }: PayloadAction<{ review?: Review }>,
    ) => {
      state.activeReview = review
    },
    setFilter: (
      state,
      {
        payload: { filter, value },
      }: PayloadAction<{ filter: FilterType; value: any }>,
    ) => {
      if (filter === 'development') {
        filter += '[]'
      }
      const currentFilters = state.filters
      if (!value && value !== 0) {
        delete currentFilters[filter]
        state.filters = {
          ...currentFilters,
        }
      } else {
        state.filters = {
          ...state.filters,
          page: 1,
          [filter]: value,
        }
      }
    },
    setReviewSort: (
      state,
      { payload: { sort } }: PayloadAction<{ sort: ISort }>,
    ) => {
      state.sort = sort
    },
    clearFilters: (state) => {
      const newFilters: any = {}
      if (state.filters?.posts_per_page) {
        newFilters.posts_per_page = state.filters.posts_per_page
      }
      state.filters = newFilters
      state.sort = null
    },
  },
})

/*
 * Export reducer for store configuration.
 */
export const reviewsReducer = reviewsSlice.reducer

export const { setActiveReview, setFilter, clearFilters, setReviewSort } =
  reviewsSlice.actions

export const getReviewsState = (rootState: unknown): ReviewsState =>
  (rootState as any)[REVIEWS_FEATURE_KEY]

export const selectActiveReview = (rootState: unknown) =>
  (rootState as any)[REVIEWS_FEATURE_KEY]?.activeReview

export const selectActiveSort = (rootState: unknown) =>
  (rootState as any)[REVIEWS_FEATURE_KEY]?.sort

export const selectReviewsFilters = (rootState: unknown) =>
  (rootState as any)[REVIEWS_FEATURE_KEY]?.filters

export const selectReviewsSort = (rootState: unknown) =>
  (rootState as any)[REVIEWS_FEATURE_KEY]?.sort
